<template>
  <div class="welcome">
    <div class="content">
      <div class="text">
        <div class="header">Welcome to <span>Loyalty XT</span> Onboarding</div>
        <div class="powered">Powered by Como</div>
        <div
          class="details"
        >Loyalty XT offers a complete toolkit for rewarding customers and engaging in rich communication, fully integrated with your Revel POS.</div>
      </div>
      <img src="/images/intro-gray.png" />
      <controls @learn="$emit('learn')" />
    </div>
  </div>
</template>

<script>
import Controls from "./Controls";

export default {
  components: {
    Controls
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.welcome {
  background-image: url("/images/intro-gray.png");
  background-size: 910px;
  background-repeat: no-repeat;
  background-position: 100% 0;

  .content {
    max-width: 460px;
    padding-top: 90px;

    .text {
       text-shadow: white 1px 1px 1px;

      .header {
        font-size: 40px;
        font-weight: bold;
        letter-spacing: 0.45px;
        color: #333d4d;
        line-height: 1.35em;
        span {
          white-space: nowrap;
        }
      }
      .powered {
        margin-top: 5px;
        font-size: 16px;
        font-weight: 600;
        font-style: italic;
        letter-spacing: 0.12px;
        color: #333d4d;
      }
      .details {
        max-width: 390px;
        margin-top: 55px;
        font-size: 22px;
        font-weight: 300;
        color: #333d4d;
        text-shadow: white 1px 1px 1px;
      }
    }

    img {
      display: none;
    }
    .controls {
      margin-top: 82px;
    }
  }

  // Mobile
  #app.mobile & {
    background-image: none;

    .content {
      max-width: initial;
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      .text {
        padding: 0 25px;
        .header {
          font-size: 26px;
          letter-spacing: 0.2px;
        }
        .powered {
          font-size: 10px;
          letter-spacing: 0.08px;
        }
        .details {
          margin-top: 20px;
          font-size: 15px;
        }
      }
      img {
        display: initial;
        width: 125vw;
        position: relative;
        right: -15vw;
      }

      .controls {
        margin-top: 40px;
      }
    }
  }
}
</style>
